import React, { useContext, useEffect, useState } from 'react'

import { Layout } from '../../atomic-components/organisms/layout'
import { Seo } from '../../atomic-components/organisms/seo'
import { SearchModal } from '../../atomic-components/molecules/searchModal'
import { ContentWrapper } from '../../atomic-components/atoms/contentWrapper'
import { TabsCasino } from '../../atomic-components/molecules/tabsCasino'
import { Carousel } from '../../atomic-components/organisms/carousel'
import { GamesCarousel } from '../../atomic-components/molecules/gamesCarousel'
import { LogosCarousel } from '../../atomic-components/molecules/logosCarousel'

import { SearchProvider } from '../../context/searchProvider'
import storageService from '../../services/storageService'
import { AuthContext } from '../../context/authProvider'
import { useTranslation } from '../../context/translationProvider'
import { getMostRecentPlayedGames } from '../../adapters/user'
import { useGamesApiData } from '../../hooks/graphqlStaticQuery/useGamesApiData'
import { useCasinoApiData } from '../../hooks/graphqlStaticQuery/useCasinoApiData'
import { pushDataLayer } from '../../utils/pushDataLayer'
import { useLocation } from '@reach/router'

const CasinoPage = ({ pageContext: { paths, type, navContext } }) => {
  const { isLoggedIn, setTriggerGeolocation } = useContext(AuthContext)
  const { translate } = useTranslation()
  const { casinoData, searchModalGames } = useCasinoApiData(type)
  const locationObj = useLocation()
  const { games } = useGamesApiData()

  useEffect(() => {
    storageService.setValue('lobby', location.pathname)
    storageService.setValue('gameLobby', location.pathname)
    
    if (locationObj.state?.triggerGeolocation) {
      setTriggerGeolocation(true)
    }
  }, [])

  const [layoutData] = useState(casinoData)
  const [playedGamesData, setPlayedGamesData] = useState()

  const addRecentlyPlayedGamesToLayout = async () => {
    const newLayoutData = [...casinoData]

    const { ok, data: userPlayedGames } = await getMostRecentPlayedGames()

    if (!ok || !userPlayedGames?.length) return
    const carousel_games = userPlayedGames.map((gameSlug) =>
      games?.find((game) => game.slug === gameSlug)
    )

    const menuRowIndex = newLayoutData?.findIndex(
      (item) => item.acf_fc_layout === 'menu_row'
    )

    const mostRecentPlayedGames = {
      acf_fc_layout: 'games_row',
      type: 'mostRecentPlayedGames',
      size: 'extraSmall',
      max_items_visible: 10,
      title: translate('casino.mostRecentPlayedGames'),
      hideGameTags: true,
      game_category: [
        {
          name: translate('casino.mostRecentPlayedGames'),
          is_visible: true,
          hide_tile: true,
          background_mode: 'dark',
          carousel_games,
        },
      ],
    }

    newLayoutData.splice(menuRowIndex + 1, 0, mostRecentPlayedGames)
    setPlayedGamesData(newLayoutData)
  }

  const fixedType = type?.replace('-', '_')
  const screenName = `${fixedType}_home`

  useEffect(() => {
    window.scrollTo({ top: 0 })
    pushDataLayer({
      eventName: 'screen-loaded',
      data: {
        screen_name: screenName,
      },
    })
  }, [type])

  useEffect(() => {
    if (isLoggedIn && games?.length > 0 && casinoData?.length > 0) {
      addRecentlyPlayedGamesToLayout()
    }
  }, [isLoggedIn, games, casinoData])

  return (
    <SearchProvider>
      <Layout page={type} eventLocation={screenName} navContext={navContext}>
        <SearchModal data={searchModalGames} casinoType={type} />

        <ContentWrapper gap="1em" gapMobile="0.75em">
          {(playedGamesData || layoutData).map((row, i) => {
            switch (row.acf_fc_layout) {
              case 'banners':
                return (
                  <Carousel
                    key={`layout-banners-${i}`}
                    slides={row.banners}
                    useGatsbyImage
                    screenName={screenName}
                    triggerGAEvent
                  />
                )
              case 'menu_row':
                return (
                  <TabsCasino
                    key={`layout-menu-${i}`}
                    content={row}
                    paths={paths}
                    screenName={screenName}
                  />
                )
              case 'games_row':
                return (
                  <GamesCarousel
                    key={`layout-games-${row.title}-${row.game_category?.[0]?.slug}-${row.type}`}
                    content={row}
                    screenName={screenName}
                    triggerGAEvent
                  />
                )
              case 'game_providers':
                return (
                  <LogosCarousel
                    key={`layout-providers-${i}`}
                    content={{
                      ...row,
                      header_title: row.title || translate('casino.providers'),
                      link: paths.providers,
                      casinoType: type,
                    }}
                    screenName={screenName}
                    triggerGAEvent
                  />
                )
              default:
                return <div key={`layout-empty-${i}`} />
            }
          })}
        </ContentWrapper>
      </Layout>
    </SearchProvider>
  )
}

export default CasinoPage

export const Head = ({
  pageContext: { hreflangPage },
  location: { pathname },
}) => {
  return <Seo hrefLangPage={hreflangPage} pathname={pathname} />
}
